module.exports = __webpack_public_path__ + "static/media/St-Lawrence-Estates.e9a89024.pdf";